module.exports = __webpack_public_path__ + "images/shimo/sheet-new-83780d4dfdf2327b89446a4d619ae2e3.png";